import React, { useMemo, useRef } from 'react'
import styled from 'styled-components'
import config from 'constants/config'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { buildRoomPackageOptionsViewOrder } from 'lib/offer/offerPageUtil'
import { getDurationPackageOptions } from 'selectors/offerPage/offerPageSelectors'
import LayoutContainer from 'components/Common/LayoutContainer'
import Caption from 'LuxKit/Typography/Caption'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import FlashHotelRoomOptionVariantWithCarousel from './FlashHotelRoomOptionVariantWithCarousel'
import { InOfferFlowContext } from './RoomOptionsContext'
import Pane from 'components/Common/Pane'
import { max } from 'lib/array/arrayUtils'

const PackagesLayoutContainer = styled(LayoutContainer)`
  padding: 0;
`

interface Props {
  offer: App.HotelOffer
  cheapestSelectedOption?: App.OfferPackageOptionView
  packageOptions: Array<App.OfferPackageOptionView>
  showFlightInformation?: boolean
}

function FlashHotelPackageOptionsVariant(props: Props) {
  const {
    offer,
    packageOptions,
    showFlightInformation,
  } = props

  const packageStartRef = useRef<HTMLDivElement>(null)

  const packageOptionsByRoom = useMemo(() => {
    return buildRoomPackageOptionsViewOrder(packageOptions)
  }, [packageOptions])

  const availableRoomCountByRoomId = useMemo(() => {
    const availablePackageOptions = packageOptions.filter(packageOption => (packageOption.availableRooms || 0) > 0)
    const packageView = max(availablePackageOptions, packageView => packageView.package.roomType?.stats.booked || 0)
    if (packageView?.availableRooms && packageView.package.roomType?.id && packageView.availableRooms > 0 && packageView.availableRooms <= 10) {
      return new Map([[packageView.package.roomType?.id, packageView?.availableRooms]])
    }
    return new Map()
  }, [packageOptions])

  return (
    <VerticalSpacer gap={16}>
      <PackagesLayoutContainer>
        <InOfferFlowContext.Provider value>
          <Pane background="neutral-six">
            <VerticalSpacer gap={8} ref={packageStartRef}>
              {packageOptionsByRoom.map((item) =>
                <FlashHotelRoomOptionVariantWithCarousel
                  key={item.roomId}
                  offer={offer}
                  packageViews={item.packageViews}
                  detailsModalMode="room-and-package"
                  availableRoomCount={availableRoomCountByRoomId.get(item.roomId)}
                />,
              )}
            </VerticalSpacer>
          </Pane>
        </InOfferFlowContext.Provider>
      </PackagesLayoutContainer>

      {showFlightInformation && (
        <LayoutContainer>
          <Caption variant="medium" align="center">
            *Price is indicative and based on sample return fares (inclusive of booking fees on Low Cost Carriers). To view live pricing, conduct a full search. {config.brandConfig.name} full Terms and Conditions apply.
          </Caption>
        </LayoutContainer>
      )}
    </VerticalSpacer>
  )
}

export default withOfferPageAndReduxState((state, appState) => ({
  offer: state.offer,
  packageOptions: getDurationPackageOptions(state, appState),
}), FlashHotelPackageOptionsVariant)
